import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

interface SubmitWizardParams {
    payload: any;
    submitFunction: (payload: any) => Promise<any>;
}

interface WizardSubmissionError {
    message: string;
    status?: number;
    code?: string;
}

export const submitWizardData = createAsyncThunk<any, SubmitWizardParams, { rejectValue: WizardSubmissionError }>(
    'wizard/submitData',
    async ({ payload, submitFunction }, { rejectWithValue }) => {
        try {
            return await submitFunction(payload);
        } catch (error) {
            if (error instanceof AxiosError) {
                const status = error.response?.status;
                let message = error?.message || 'Submission failed. Please try again.';

                return rejectWithValue({
                    message,
                    status,
                    code: error.code,
                });
            }

            return rejectWithValue({
                message: error instanceof Error ? error.message : 'An unexpected error occurred',
            });
        }
    }
);
